import type { AuthStatus } from "@/common/enums/enums";
import type { AppIdentity } from "@/lib/native-auth";
import { clearVisitSubmissions } from "@/lib/visit-submission";
import type { UserData } from "@/services/auth";
import { useNativeAuthStore } from "./native-auth.store";

export interface AuthState {
  authStatus: AuthStatus;
  user: AppIdentity | null;
  userData: null | UserData;
  loading: boolean;
  error: string | null;
  signIn: (email: string, password: string) => Promise<void>;
  signInWithGoogle: (options?: { occupationId?: number }) => Promise<void>;
  linkGoogleAccount: () => Promise<void>;
  reSignIn: (user: AppIdentity | null) => Promise<void>;
  signInWithCurrentUser: () => Promise<void>;
  signOut: () => Promise<void>;
  setUser: (user: AppIdentity | null) => void;
  forgotPassword: (email: string) => Promise<void>;
  getUser: () => Promise<void>;
}

export const useAuthStore = useNativeAuthStore;

// Do not carry another account's pending retry identity across sign-out/switch.
useAuthStore.subscribe((state, previous) => {
  if (previous.user && state.user?.uid !== previous.user.uid) {
    try {
      clearVisitSubmissions();
    } catch {
      /* Storage may be unavailable. Account-scoped keys still isolate requests. */
    }
  }
});
